<template>
    <div v-if="show" :class="{ 'has-subroutes': hasSubroutes }" class="link-list">
        <div class="link-list-wrapper">
            <router-link
                v-for="route in routes"
                :key="route.id"
                :to="{ name: route.name, params: route.params }"
                class="link-list-item">
                <div class="link-list-item-wrapper">
                    <slot :route="route">
                        <i :class="route.icon" class="icon" />
                        <span>{{ route.title }}</span>
                    </slot>

                    <div v-if="route.subroutes && route.subroutes.length > 0" class="item-submenu">
                        <router-link
                            v-for="route in route.subroutes"
                            :key="route.id"
                            :to="{ name: route.name, params: route.params }"
                            class="link-list-item">
                            <div class="link-list-item-wrapper">
                                <slot :route="route">
                                    <i :class="route.icon" class="icon" />
                                    <span>{{ route.title }}</span>
                                </slot>
                            </div>
                        </router-link>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'link-list',
    props: {
        routes: {
            type: Array,
            default() {
                return []
            }
        }
    },
    computed: {
        show() {
            return this.routes.length > 0
        },
        subroutes() {
            return this.routes
                .filter(route => route.name == this.$route.name && route.subroutes)
                .map(item => item.subroutes)
                .reduce((a, b) => a.concat(b), [])
        },
        hasSubroutes() {
            return this.subroutes.length > 0
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.link-list
    margin-bottom: -15px
    padding-right: 15px
    min-width: 200px
    flex-shrink: 0
    position: relative

    .link-list-item
        padding: 8px 20px
        margin-bottom: 5px
        display: block
        text-decoration: none
        color: $text-dark-grey
        border-radius: 12px
        font-size: 15px

        &:visited
            color: $text-dark-grey

        .link-list-item-wrapper
            padding: 10px 0px
            vertical-align: bottom

        &:hover
            background: $white
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08)

        &:hover:not(.router-link-active) span
            text-decoration: underline

        &.router-link-active
            background: $white
            color: $dark-blue
            font-weight: bold
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08)

            .item-submenu
                display: block

        .icon
            margin-right: 10px

            &:before
                display: inline-block
                padding-top: 1px
                vertical-align: text-top

        .item-submenu
            display: none
            align-self: flex-start
            border-radius: 12px
            margin: 10px 0 -10px

            .link-list-item
                width: auto

                &.router-link-active
                    background: $dark-blue
                    color: $white

    @media screen and (max-width: 1024px)
        min-width: 150px
        padding-right: 10px

    @media screen and (max-width: 480px)
        padding: 0px 20px 30px
</style>
